import React from 'react';

import { SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import styled from 'styled-components';
import { prop } from 'styled-tools';

const CarouselCardContainer = styled.div`
  background-color: ${prop('theme.colors.white')};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  &:hover {
    cursor: grab;
  }
`;

interface CarouselCardProps {
  children: React.ReactNode;
}

function CarouselCard({ children }: CarouselCardProps) {
  return (
    <SplideSlide>
      <CarouselCardContainer>{children}</CarouselCardContainer>
    </SplideSlide>
  );
}

export default CarouselCard;
